module.exports = __webpack_public_path__ + "img/info_sp_02.eca66ff5.png";